<template>
  <div class="app-container">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="160px"
    >
      <el-form-item label="banner图片" prop="banner_url">
        <el-upload
          name="file[]"
          :data="{ type: 'image' }"
          class="avatar-uploaders1"
          :class="ruleForm.banner_url ? 'hide' : ''"
          :action="ossUpload"
          accept=".jpg,.png,.jpeg"
          :headers="{ token: token }"
          list-type="picture-card"
          :show-file-list="true"
          :file-list="fileList"
          :limit="1"
          :on-remove="
            (file, fileList) => {
              handleRemovePic(file, fileList, 'banner_url');
            }
          "
          :on-success="
            (res, file, fileList) => {
              handleAvatarSuccess(res, file, fileList, 'banner_url');
            }
          "
          :disabled="cztype == 'see'"
          :on-exceed="() => exceed('banner图片', 1)"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i> 
          </el-upload>
        <div class="pic-tips">banner图宽高比建议 2.8:1</div>
      </el-form-item>
      <el-form-item label="附件上传" prop="download_url">
        <el-upload
          v-if="cztype != 'see'"
          accept=".doc,.xls,.xlsx,.pdf"
          :on-success="handleFileSuccess"
          ref="upload"
          name="file[]"
          :data="{ type: 'file' }"
          :headers="{ token: token }"
          :action="ossUpload"
          :multiple="true"
          :limit="1"
          v-loading.fullscreen.lock="loading"
          element-loading-text="上传中..."
          :before-upload="beforeUploadFn"
        >
          <el-button size="small" type="primary"
            >点击上传</el-button
          > </el-upload>
        <el-input
          disabled
          v-model="ruleForm.download_url"
          placeholder="请上传附件"
        ></el-input>
      </el-form-item>
      <el-form-item label="文件名称" prop="filename">
        <el-input
          :disabled="cztype == 'see'"
          v-model="ruleForm.filename"
          placeholder="文件名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="文章内容" prop="details">
        <Editor
            ref="myQuillEditor"
            :disabled="cztype == 'see'"
            style="width: 100%"
            v-model="ruleForm.details"
            placeholder="请输入文章内容"
          />
      </el-form-item>
       <el-form-item v-if="cztype == 'edit'&&roles.includes('/policy/set_banner')">
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >
          立即修改
        </el-button>
        <el-button type="info" @click="getInfo()"> 取消 </el-button>
      </el-form-item>
      <el-form-item v-else>
        <el-button type="success" v-if="roles.includes('/policy/set_banner')" @click="cztype = 'edit'"> 修改 </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { get_system_conf } from "@/api/common"
import { set_fund } from "@/api/sharedOffice";
import { openPark, delImage } from "@/api/index";
import { getToken } from "@/utils/auth";
import Editor from "@/components/Editor";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      ruleForm: {
        banner_url:"",
        filename:"",
        details:"",
        download_url:""
      },
      fileList: [],
      rules: {
        banner_url: [{ required: true, message: "请选择banner图片" }],
        filename: [
          { required: true, message: "请输入文件名称", trigger: "blur" },
        ],
        details: [
          { required: true, message: "请输入文章内容", trigger: "blur" },
        ],
        download_url: [
          { required: true, message: "请上传附件", trigger: "blur" },
        ],
      },
      cztype: "see",
      ossUpload: this.$store.state.ossUpload,
      clearPics: [],
      loading: false,
    };
  },
  created() {
    // if (this.userInfo.park_id !== 0) {
    //   this.screen.park_id = this.userInfo.park_id;
    // } else {
    //   this.screen.park_id = "";
    // }
    this.fileList = [];
    this.getInfo();
  },
  methods: {
    exceed(msg, num) {
      this.$message.warning(`${msg}仅限${num}张，请先移除原有图片！`);
    },
    handleRemovePic(file, fileList, type) {
      if (file.response.data.url) {
        this.clearPics.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm[type] = list.join(",");
    },
    delImges() {
      if (this.clearPics.length) {
        delImage({ file: this.clearPics.join(",") }).then((ress) => {});
      }
    },
    beforeUploadFn() {
      this.loading = true;
    },
     handleAvatarSuccess(res, file, fileList, type) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.ruleForm[type] = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
    },
    // 上传
    handleFileSuccess(res, file) {
      this.loading = false;
      if (res.code === 200) {
        this.ruleForm.download_url = this.imageOss + res.data.url;
      }
      this.$refs.upload.clearFiles();
    },
    // 获取信息
    getInfo() {
      var that = this;
      get_system_conf({key:'policy_banner_article'}).then((res) => {
        that.cztype = "see"
        var data = Object.keys(res.data.info)
        if(!data.length) {
          return
        }
        that.ruleForm = {
          banner_url: res.data.info.value.banner_url || "",
          download_url: res.data.info.value.download_url || "",
          filename: res.data.info.value.filename || "",
          details: res.data.info.value.details || "",
        };
        var bannerList = res.data.info.value.banner_url.split(",");
        this.fileList = bannerList.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
      });
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认修改？")
            .then(() => {
              set_fund(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.delImges();
                  that.$message.success("修改成功！");
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
